/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { V1RequestStateString } from '../../entities/v1/RequestStateString'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { z } from 'zod'

export const v1RequestStateStringSchema = z.enum(['idle', 'checkin', 'accept', 'decline', 'unknown']) as unknown as ToZod<V1RequestStateString>